module.exports = __webpack_public_path__ + "static/media/1012662.bf3949a3.jpg";